import { Link } from 'react-router-dom'
import { Calendar, MapPin, Users, ArrowRight } from 'lucide-react'
import { getImageUrl } from '../utils/imageHelper'

const EventCard = ({ event }) => {
  const { id, title, description, date, location, image, maxAttendees, currentAttendees, category, slug } = event

  const formatDate = (dateString) => {
    const eventDate = new Date(dateString)
    return eventDate.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const formatTime = (dateString) => {
    const eventDate = new Date(dateString)
    return eventDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
  }

  const isUpcoming = new Date(date) > new Date()
  const isFull = maxAttendees && currentAttendees >= maxAttendees

  return (
    <div className="card group hover:scale-105 transition-transform duration-300">
      {/* Event Image */}
      <div className="relative overflow-hidden">
        <img
          src={getImageUrl(image)}
          alt={title}
          className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-earth-green text-white px-3 py-1 rounded-full text-sm font-medium capitalize">
            {category}
          </span>
        </div>
        {!isUpcoming && (
          <div className="absolute top-4 right-4">
            <span className="bg-gray-600 text-white px-3 py-1 rounded-full text-sm font-medium">
              Past Event
            </span>
          </div>
        )}
        {isFull && isUpcoming && (
          <div className="absolute top-4 right-4">
            <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-medium">
              Full
            </span>
          </div>
        )}
      </div>

      {/* Event Info */}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-earth-green transition-colors">
          {title}
        </h3>
        <p className="text-gray-600 mb-4 line-clamp-2">{description}</p>

        {/* Event Details */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center text-gray-600">
            <Calendar className="h-5 w-5 mr-3 text-brand-blue" />
            <div>
              <div className="font-medium">{formatDate(date)}</div>
              <div className="text-sm">{formatTime(date)}</div>
            </div>
          </div>

          <div className="flex items-center text-gray-600">
            <MapPin className="h-5 w-5 mr-3 text-earth-green" />
            <div>
              <div className="font-medium">{location.name}</div>
              <div className="text-sm">{location.city}, {location.state}</div>
            </div>
          </div>

          {maxAttendees && (
            <div className="flex items-center text-gray-600">
              <Users className="h-5 w-5 mr-3 text-brand-blue" />
              <div>
                <div className="font-medium">
                  {currentAttendees} / {maxAttendees} attendees
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                  <div
                    className="bg-brand-blue h-2 rounded-full transition-all duration-300"
                    style={{ width: `${(currentAttendees / maxAttendees) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Action Button */}
        <Link
          to={`/events/${id}`}
          className="btn-primary w-full flex items-center justify-center group"
        >
          View Details
          <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  )
}

export default EventCard
